<template>
  <ul class="nav flex-column menu-list list-unstyled">
    <li class="menu-list__item">
      <a
        class="w-100 d-flex flex-row justify-content-between"
        data-bs-toggle="collapse"
        href="#collapse"
        role="button"
        aria-expanded="false"
        :style="{ fontWeight: isActive ? 800 : 500 }"
        @click="() => handleClick()"
      >
        <div>
          <Icon class="me-3" name="fingerprint"></Icon
          ><span>Instalação de SSL</span>
        </div>
        <Icon name="angle-down"></Icon>
      </a>
    </li>
    <div id="collapse" ref="menuRef" :class="['collapse', { show: isActive }]">
      <ul class="submenu-list btn-toggle-nav list-unstyled pb-1 small">
        <li
          v-for="(url, name) in menuSSLInstallation"
          :key="url + name"
          class="submenu-list__item"
        >
          <Icon class="me-3" name="arrow-right"></Icon>
          <router-link :to="`${url}`" @click="() => handleClick(true)">
            <span data-bs-dismiss="offcanvas">{{ name }}</span></router-link
          >
        </li>
      </ul>
    </div>
  </ul>

  <div class="nav flex-column menu-list list-unstyled mt-4">
    <router-link
      to="digital-certificate-plugin"
      class="w-100 d-flex flex-row justify-content-between"
      :style="{
        fontWeight: isCurrentRoutePluginHelpPage && !isActive ? 800 : 500,
      }"
    >
      <div class="d-flex fle-row align-items-center">
        <Icon class="me-3" name="display-arrow-down"></Icon>
        <span>Plugin de instalação de Certificados Digitais A1</span>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  export default defineComponent({
    name: 'FAQSidebar',
    components: {
      Icon,
    },
    data: () => ({
      menuSSLInstallation: {
        'Gerar requisição (CRS)': 'generate-csr-request',
        'Assinar termo digital': 'sign-digital-term',
        'Instalar Open SSL - Windows': 'install-open-ssl-windows',
        'AWS KMS': 'aws-kms',
      },
      active: true,
    }),
    computed: {
      isCurrentRoutePluginHelpPage() {
        return this.$router.currentRoute.value.path.includes(
          'digital-certificate-plugin',
        )
      },
      isActive() {
        return this.active && !this.isCurrentRoutePluginHelpPage
      },
    },
    methods: {
      handleClick(setActive = true) {
        this.active = setActive || !this.isCurrentRoutePluginHelpPage
      },
    },
  })
</script>

<style lang="stylus">
  a
    text-decoration: none;
    color: #2F3242
    &:hover,
    &:focus
      text-decoration: none;
      color: #2F3242
  .menu-list
    text-align: left
  .menu-list__item
    a
      width: 100%
    .dropdown
      .link-dark
        color: #2F3242 !important
        &:after
          color: red !important
  .submenu-list
    font-size: 1rem
    padding-left: 1rem
    .submenu-list__item
      margin-top: 1rem
      .active
        font-weight: 700
</style>
